var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.983,
    height: 29.579,
    viewBox: "0 0 27.983 29.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.475,35.74a.367.367,0,0,0,.558,0L94.3,27.393a.488.488,0,0,0,.116-.321.48.48,0,0,0-.116-.319.367.367,0,0,0-.558,0l-6.593,7.574V15.282a.4.4,0,1,0-.789,0V34.326l-6.592-7.574a.36.36,0,0,0-.558,0,.5.5,0,0,0,0,.641Z",
    transform: "translate(-73.263 -14.829)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,419.625c-.264,0-.48.3-.48.671V424H.961v-3.7c0-.37-.216-.671-.48-.671s-.48.3-.48.671v4.373c0,.37.215.672.48.672H26.5c.265,0,.48-.3.48-.672V420.3C26.984,419.927,26.769,419.625,26.5,419.625Z",
    transform: "translate(-0.001 -396.763)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.75147cccd72d6e5222c4324a2e1fc9db.svg";
export { ForwardRef as ReactComponent };